import { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { PageTitle } from '../../../../../_metronic/layout/core'
import { useThemeMode } from '../../../../../_metronic/partials'
import { DisplayImage } from '../../../widgets/components/General/DisplayImage'
// import { IndividualAttatchments } from "../../stakeholders-and-investors/components/individual/attatchments-individuals"
import { Meetingtable } from '../../stakeholders-and-investors/components/meetings-table'
import { AdvisorsAndMentorsDetailsBreadcrum } from '../core/_constants'
import { IndividualAdvisorsAndMentorsProfile } from '../components/individual-advisors-mentors-profile'
import { useDateFormat } from '../../../../hooks/useDateFormat'
import { useNavigate, useParams } from 'react-router-dom'
import { useAuth } from '../../../auth'
import { getAdvisorsMentorsDetails } from '../core/_requests'
import Skeleton from 'react-loading-skeleton'
import { IndividualAttatchments } from '../../stakeholders-and-investors/components/individual/attatchments-individuals'
import { StakeholderModuleTypes } from '../../../../core/_constants'
import { toTitleCase } from '../../../../core/_util'
import TagManager from 'react-gtm-module'
import { GTMEvent } from '../../../../hooks/gtmHelpers'

export default function IndividualAdvisorsMentorsDetails() {
  const { formatMessage } = useIntl()
  const sidebarOptions = [
    { title: formatMessage({ id: 'Meetings' }) },
    { title: formatMessage({ id: 'Profile' }) },
    { title: formatMessage({ id: 'Attachments' }) },
  ]

  const { mode } = useThemeMode()
  const [sidebar, setSidebar] = useState(1)
  const { getDateValue } = useDateFormat()
  const [advisorsMentorsDetails, setAdvisorsMentorsDetails] = useState<any>(null)
  const [loading, setLoading] = useState<boolean>(false)
  const { advisorMentorId } = useParams()
  const { companyId, currentUser } = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    if (!advisorMentorId || !companyId) return
    fetchAdvisorsMentors()
  }, [advisorMentorId]) // eslint-disable-line react-hooks/exhaustive-deps
  const fetchAdvisorsMentors = async () => {
    if (!advisorMentorId || !companyId) return
    setLoading(true)
    try {
      const {
        data: { data, success, errors },
      } = await getAdvisorsMentorsDetails(advisorMentorId, companyId)
      if (success) {
        setAdvisorsMentorsDetails(data)
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.AdvisorsMentorsDetailsAccessSuccessful,
            action: 'normal',
            metadata: {
              company_id: companyId,
              user_id: currentUser?.userId,
              email: currentUser?.email,
              advisors_mentors_details: data,
            },
          },
        })
      } else {
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.AdvisorsMentorsDetailsAccessFailed,
            action: 'normal',
            metadata: {
              company_id: companyId,
              user_id: currentUser?.userId,
              email: currentUser?.email,
              error: errors[0],
            },
          },
        })
      }
    } catch (error) {
      console.error('Error fetching countries:', error)
      TagManager.dataLayer({
        dataLayer: {
          event: GTMEvent.AdvisorsMentorsDetailsAccessFailed,
          action: 'normal',
          metadata: {
            company_id: companyId,
            user_id: currentUser?.userId,
            email: currentUser?.email,
            error: error,
          },
        },
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <PageTitle
        breadcrumbs={AdvisorsAndMentorsDetailsBreadcrum}
        description={formatMessage({ id: 'Advisors and Mentors Details' })}
      >
        {formatMessage({ id: 'Advisors and Mentors' })}
      </PageTitle>

      <div className='mt-4 mb-8'>
        <div className='bg-white w-100 p-4 rounded-top'>
          <div className='d-md-flex justify-content-end w-100 align-items-center  mb-4 px-4 '>
            <button
              className='btn btn-light justify-content-center text-mute font-weight-400 font-size-13 height-36 d-flex align-items-center w-md-auto w-100'
              onClick={() => {
                navigate(
                  `/stakeholders/add-advisors-and-mentors?tab=${advisorsMentorsDetails?.type}&advisorMentorId=${advisorsMentorsDetails?.advisorMentorId}&edit=true`
                )
              }}
            >
              {formatMessage({ id: 'Edit' })}
            </button>
          </div>

          <div className='d-md-flex gap-4 px-4'>
            {loading ? (
              <Skeleton
                height={120}
                width={120}
                baseColor='var(--kt-skeleton-bg-color)'
                highlightColor='var(--kt-skeleton-highlight-bg-color)'
              />
            ) : (
              <DisplayImage
                imgName={advisorsMentorsDetails?.individual?.profileImage?.name}
                width={120}
                height={120}
                alt='investor logo'
                fit='contain'
                className='mb-4'
              />
            )}
            <div className='w-100'>
              <div className='d-flex gap-2 align-items-center'>
                {loading ? (
                  <Skeleton
                    height={30}
                    width={120}
                    baseColor='var(--kt-skeleton-bg-color)'
                    highlightColor='var(--kt-skeleton-highlight-bg-color)'
                  />
                ) : (
                  <h2 className='font-size-20 m-0'>
                    {advisorsMentorsDetails?.individual?.firstName}{' '}
                    {advisorsMentorsDetails?.individual?.lastName}
                  </h2>
                )}
                {loading ? (
                  <Skeleton
                    height={30}
                    width={60}
                    baseColor='var(--kt-skeleton-bg-color)'
                    highlightColor='var(--kt-skeleton-highlight-bg-color)'
                  />
                ) : (
                  <div
                    className={`badge px-4 py-2 ${advisorsMentorsDetails?.type === 'individual'
                      ? 'badge-light-warning'
                      : advisorsMentorsDetails?.type === 'institution'
                        ? 'badge-light-primary'
                        : ''
                      }`}
                  >
                    {advisorsMentorsDetails?.type ? toTitleCase(advisorsMentorsDetails?.type) : '-'}
                  </div>
                )}
              </div>
              <div className='pe-4 pt-2'>
                <div className='pe-4 pt-2'>
                  {loading ? (
                    <Skeleton
                      height={20}
                      width={90}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  ) : (
                    <a
                      href={
                        advisorsMentorsDetails?.individual?.website?.startsWith('http')
                          ? advisorsMentorsDetails?.individual?.website
                          : `https://${advisorsMentorsDetails?.individual?.website}`
                      }
                      target='_blank'
                      rel='noreferrer'
                      className='text-primary m-0'
                    >
                      {advisorsMentorsDetails?.individual?.website}
                    </a>
                  )}
                </div>
              </div>

              <div className='d-flex d-md-block'>
                <div className='w-100 my-6'>
                  <div className='row gx-8 justify-content-between'>
                    <div className='col-lg-2 col-md-6 mb-4 mb-md-auto'>
                      <p className='text muted font-size-12 mb-0'>
                        {formatMessage({ id: 'Designation' })}
                      </p>
                      {loading ? (
                        <Skeleton
                          height={20}
                          width={120}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      ) : (
                        <p className='font-size-14 mb-0'>
                          <p className='font-size-13 mb-0'>
                            {advisorsMentorsDetails?.designation
                              ? `${advisorsMentorsDetails?.designation}`
                              : '-'}
                          </p>
                        </p>
                      )}
                    </div>
                    <div className='col-lg-2 col-md-6 mb-4 mb-md-auto'>
                      <p className='text muted font-size-12 mb-0'>{formatMessage({ id: 'Phone' })}</p>
                      {loading ? (
                        <Skeleton
                          height={20}
                          width={120}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      ) : (
                        <p className='font-size-14 mb-0'>
                          <p className='font-size-13 mb-0'>
                            {advisorsMentorsDetails?.individual?.phoneNumber
                              ? `${advisorsMentorsDetails.individual.phoneNumber}`
                              : '-'}
                          </p>
                        </p>
                      )}
                    </div>
                    <div className='col-lg-3 col-md-12 mb-4 mb-md-auto'>
                      <p className='text muted font-size-12 mb-0'>
                        {formatMessage({ id: 'Email Id' })}
                      </p>
                      {loading ? (
                        <Skeleton
                          height={20}
                          width={180}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      ) : (
                        <p className='font-size-14 mb-0 me-4'>
                          {advisorsMentorsDetails?.individual?.email || '-'}
                        </p>
                      )}
                    </div>
                    <div className='col-lg-2 col-md-6 mb-4 mb-md-auto'>
                      <p className='text muted font-size-12 mb-0'>
                        {formatMessage({ id: 'Nationality' })}
                      </p>
                      {loading ? (
                        <Skeleton
                          height={20}
                          width={130}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      ) : (
                        <p className='font-size-14 mb-0'>
                          {advisorsMentorsDetails?.individual?.nationality?.label || '-'}
                        </p>
                      )}
                    </div>
                    <div className='col-lg-2 col-md-6 mb-4 mb-md-auto'>
                      <p className='text muted font-size-12 mb-0'>
                        {formatMessage({ id: 'Date of birth' })}
                      </p>
                      {loading ? (
                        <Skeleton
                          height={20}
                          width={90}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      ) : (
                        <p className='font-size-14 mb-0'>
                          {advisorsMentorsDetails?.individual?.dateOfBirth
                            ? getDateValue(advisorsMentorsDetails?.individual?.dateOfBirth)
                            : '-'}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='rounded-bottom sidebar-investor-db col-md-1 d-flex bg-white' style={{ width: '100%' }}>
          <div
            className=' d-flex'
            style={{
              display: 'flex',
              overflowX: 'scroll',
              whiteSpace: 'nowrap',
              scrollbarWidth: 'none',
              msOverflowStyle: 'none',
            }}
          >
            {sidebarOptions.map((sideTabs: any, index: number) => (
              <>
                <ul
                  className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent text-muted  flex-nowrap mobile-tab-both my-md-0 mb-0 px-2'
                  style={{ display: 'flex', flexWrap: 'nowrap' }}
                >
                  <li
                    key={index}
                    className={
                      `nav-link text-active-primary cursor-pointer py-3 ps-3 d-flex align-items-center` +
                      (sidebar === index + 1
                        ? '  border-top-0 border border-left-0 border-right-0 border-bottom-3 border-primary text-primary border-5'
                        : '')
                    }
                    onClick={() => setSidebar(index + 1)}
                  >
                    {sideTabs.title}
                  </li>
                </ul>
              </>
            ))}
          </div>
        </div>
        <div
          className={`d-flex mb-4 rounded-2 w-100 `}
          style={mode === 'dark' ? { background: '#151521' } : { background: '#f5f8fa' }}
        >
          {sidebar === 1 ? (
            <>
              {advisorsMentorsDetails?.individual?.email ? (
                <div className='mt-3 w-100'>
                  <div className='w-100'>
                    <Meetingtable email={advisorsMentorsDetails?.individual?.email} />
                  </div>
                </div>
              ) : (
                <div className='w-100 mt-3'>
                  {/* <div className='d-md-flex  mb-2 mt-5 justify-content-between w-100 align-items-center'>
                    <h1 className='font-size-16 mb-0'>{formatMessage({ id: 'Meetings' })}</h1>
                  </div> */}
                  <div className='table table-responsive h-100 bg-white px-4 py-2'>
                    <Skeleton
                      width={'100%'}
                      height={48}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                    <Skeleton
                      width={'100%'}
                      height={48}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  </div>
                </div>
              )}
            </>
          ) : sidebar === 2 ? (
            <div className='mt-3 w-100'>
              <div className='w-100'>
                <IndividualAdvisorsAndMentorsProfile
                  advisorsMentorsDetails={advisorsMentorsDetails}
                  loading={loading}
                />
              </div>
            </div>
          ) : (
            <div className='mt-3 w-100'>
              <div className='w-100'>
                <IndividualAttatchments
                  stakeholdersDetails={advisorsMentorsDetails}
                  loading={loading}
                  id={advisorsMentorsDetails?.advisorMentorId}
                  type={StakeholderModuleTypes.ADVISORS_MENTORS}
                  fetchTeamMemberDetails={fetchAdvisorsMentors}
                />
              </div>
            </div>
          )}
        </div>
      </div >
    </>
  )
}
